module.exports = __webpack_public_path__ + "static/media/moon-cloud.972e3252.svg";